module.exports = __webpack_public_path__ + "components/page-header/static/mountain-badge-008807b02b73b64428ae389f252d9123.svg";